<template>
  <a-layout-sider :width="width" class="pr-layout-sider" theme="light">
    <a-menu
      v-model:selectedKeys="selectedKeys"
      v-model:openKeys="openKeys"
      class="admin-menu"
      mode="inline"
      :inlineIndent="0"
    >
      <template v-for="(item, index) in menus" :key="index">
        <a-menu-item
          v-if="item.children == null"
          :key="item.fullPath"
          @click="clickhandel(item)"
        >
          <template #icon>
            <svg-icon :icon-class="item.meta.icon"></svg-icon>
          </template>
          <div class="menu-item-title">{{ $t('admin.' + item.title) }}</div>
        </a-menu-item>
        <a-sub-menu v-else :key="item.fullPath">
          <template #icon>
            <svg-icon :icon-class="item.meta.icon"></svg-icon>
          </template>
          <template #expandIcon>
            <CaretDownOutlined />
          </template>
          <template #title>{{ $t('admin.' + item.title) }}</template>

          <a-menu-item
            v-for="subItem in item.children"
            :key="subItem.fullPath"
            @click="clickhandel(subItem)"
          >
            {{ $t('admin.' + subItem.title) }}
          </a-menu-item>
        </a-sub-menu>
      </template>
    </a-menu>
  </a-layout-sider>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { CaretDownOutlined } from '@ant-design/icons-vue'

  export default {
    name: 'PrSider',
    components: { CaretDownOutlined },
    props: {
      width: {
        type: Number,
        default: 208,
      },
    },
    data() {
      return {
        selectedKeys: [],
        openKeys: [],
      }
    },
    watch: {
      $route: {
        handler({ path, matched }) {
          // console.log(path, matched)
          if (matched && matched.length > 0) {
            matched[0]?.children.length > 1
              ? (this.selectedKeys = [path])
              : (this.selectedKeys = [matched[0].path])
            if (matched.length - 2 >= 0) {
              this.openKeys = [matched[matched.length - 2].path]
            } else {
              this.openKeys = [matched[0].path]
            }
          } else {
            console.log('ROUTE ERR.')
          }
        },
        immediate: true,
      },
    },
    computed: {
      ...mapGetters({ menus: 'routes/adminMenus' }),
    },
    methods: {
      clickhandel(route) {
        const { fullPath } = route
        this.$router.push({ path: fullPath })
      },
    },
  }
</script>

<style lang="less">
  @import url('@/styles/params.less');

  .pr-layout-sider {
    box-shadow: 2px 0px 6px 0px rgba(31, 31, 31, 0.12);
    padding: 32px 16px;
    text-align: center;
    z-index: 9;
    .admin-menu {
      text-align: center;
      border: none;
      background: white;
      .menu-item-title {
        margin: 2px auto;
      }
      .ant-menu-item-icon {
        font-size: 36px;
      }
    }
    .ant-menu-submenu-open {
      .anticon {
        transform: rotateX(180deg);
      }
    }
    .ant-menu-inline.ant-menu-root .ant-menu-item,
    .ant-menu-inline.ant-menu-root .ant-menu-submenu-title {
      &::after {
        display: none;
      }
      display: block;
      margin: 0;
      padding: 12px 0 !important;
      font-size: 16px;
      font-family: Helvetica;
      height: auto;
      line-height: 24px;
      letter-spacing: 1px;
      &:nth-child(1) {
        margin: 0 !important;
      }
    }

    .ant-menu-inline.ant-menu-root .ant-menu-item > .ant-menu-title-content,
    .ant-menu-inline.ant-menu-root
      .ant-menu-submenu-title
      > .ant-menu-title-content {
      display: block;
      text-align: center;
      padding: 0;
      margin: 8px auto 0px auto;
    }
    .ant-menu-sub.ant-menu-inline {
      background: white;
    }
    .ant-menu-submenu.ant-menu-submenu-inline {
      margin-top: 8px;
    }
  }
</style>
